import { initProductCardColorVariant } from "./productCardColorVariant";
import { initSwipers } from "./sliders";
import { initHeaderSearch } from "./headerSearch";
import { initMenuDropdown } from "./menuDropdown";
import { initToggleMenuMobile } from "./menuMobile";
import { stickyHeader } from "./stickyHeader";
import { initQuickView } from "./quickView";
import { initAccordions } from "./accordions";
import { initMediaGallery } from "./mediaGallery";
import { initAllAccordions } from "./allAccordions";
import { autoFiltering, toggleFilters, filterMobile } from "./productsFilters";
import { stickyAddToCart } from "./stickyAddToCart";
import { initPointers } from "./pointers";
import { initProductVariants } from "./productVariant";
import { initSizeChart } from "./popups";
import { countdown } from "./countdown";
import { initImageZoom } from "./imageZoom";
import { galleryPopup } from "./galleryPopup";
import { wholesalePassword } from "./wholesalePassword";
document.addEventListener("DOMContentLoaded", function () {
  var node = document.querySelector('.preload-transitions');
  node.classList.remove('preload-transitions');
  // init the Menu Mobile Toggling
  countdown();
  initToggleMenuMobile();
  stickyHeader();
  initMenuDropdown();
  initHeaderSearch();
  initSwipers();
  initProductCardColorVariant();
  initQuickView();
  toggleFilters();
  autoFiltering();
  filterMobile();
  initAccordions();
  initMediaGallery();
  initAllAccordions();
  stickyAddToCart();
  initPointers();
  initProductVariants();
  initSizeChart();
  initImageZoom();
  galleryPopup();
  wholesalePassword();
});